// Two behaviours the sidebar used to carry as inline onclick attributes. A Content-Security-Policy without
// 'unsafe-inline' does not run an event-handler attribute, so they are declared as data attributes and handled here
// by one delegated listener (W10-4).
//
//   data-submit-form="<form id>"        – submit that form instead of following the link (logout is a POST route).
//   data-ignore-click-from="<min px>"   – swallow the click at or above that viewport width (the active link is
//                                          inert on a wide screen, where the sidebar is always visible).
document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;

    const submit = target?.closest('[data-submit-form]');
    if (submit) {
        event.preventDefault();
        document.getElementById(submit.dataset.submitForm)?.submit();
        return;
    }

    const inert = target?.closest('[data-ignore-click-from]');
    if (inert && window.innerWidth >= Number(inert.dataset.ignoreClickFrom)) {
        event.preventDefault();
    }
});
